// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

// Firebase SDK reference: https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase Authentication and get a reference to the service
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

// Use Emulator for Firebase Functions only if explicitly enabled
// Set REACT_APP_USE_EMULATOR=true in .env.local to use local emulator
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectFunctionsEmulator(functions, "localhost", 5001);
}

// Export the Firebase services that you want to use
export const db = getFirestore(app);
export const authFirebase = getAuth(app);
export { functions };